import { useTranslations } from '@npco/common-utils-translations'
import { Field } from 'formik'

import { FormCheckbox } from 'components/Input/Checkbox'

import { setupFlowAccountsStageTranslations } from '../../FeatureAccountsStage.i18n'
import * as styled from './AccountStageCheckbox.styled'

export const AccountStageCheckboxField = () => {
  const t = useTranslations(setupFlowAccountsStageTranslations)

  return (
    <Field
      component={FormCheckbox}
      name="isCreateCardAllowed"
      type="checkbox"
      alignItems="end"
    >
      <styled.Label>{t('checkboxMessage')}</styled.Label>
    </Field>
  )
}
